import { createSelector } from 'reselect';

const selectCommunityMessage = state => state.get('communityMessage');

export const selectCurrentId = () =>
  createSelector(selectCommunityMessage, cm => cm.get('currentId'));
export const selectPreviousId = () =>
  createSelector(selectCommunityMessage, cm => cm.get('previousId'));



// WEBPACK FOOTER //
// ./src/containers/CommunityMessageContainer/selectors.js